export class IcebergSnapshotEntry {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "parentSnapshotId",
            "baseName": "parentSnapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "committedAt",
            "baseName": "committedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "operation",
            "baseName": "operation",
            "type": "string",
            "format": ""
        },
        {
            "name": "isCurrent",
            "baseName": "isCurrent",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "addedRecords",
            "baseName": "addedRecords",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "deletedRecords",
            "baseName": "deletedRecords",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "totalRecords",
            "baseName": "totalRecords",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "totalDataFiles",
            "baseName": "totalDataFiles",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "totalFileSizeBytes",
            "baseName": "totalFileSizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "summary",
            "baseName": "summary",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IcebergSnapshotEntry.attributeTypeMap;
    }
    constructor() {
    }
}
